import { CalendarDate } from "@gemma/dates";

interface IContract {
  start: Readonly<CalendarDate>;
  end?: Readonly<CalendarDate>;
}

export function contractorDisabledDates() {
  return {
    computed: {
      startDateDisabledDates(this: { contract?: IContract; selectedContract?: IContract; form: { endDate: Date | CalendarDate } }) {
        const contract = this.contract || this.selectedContract;
        const contractStartDate = contract && contract.start && CalendarDate.parse(contract.start);
        let _cannotStartBefore = contractStartDate;

        const contractorEndDate = this.form.endDate && CalendarDate.parse(this.form.endDate);
        const contractEndDate = contract && contract.end && CalendarDate.parse(contract.end);
        let _cannotStartAfter = contractEndDate ? (contractorEndDate && contractorEndDate.isBefore(contractEndDate) ? contractorEndDate : contractEndDate) : contractorEndDate;

        const cannotStartAfter = _cannotStartAfter && CalendarDate.parse(_cannotStartAfter)!.asDate;
        const cannotStartBefore = _cannotStartBefore && CalendarDate.parse(_cannotStartBefore)!.asDate;

        return { from: cannotStartAfter, to: cannotStartBefore };
      },
      endDateDisabledDates(this: { contract?: IContract; selectedContract?: IContract; form: { startDate: Date | CalendarDate } }) {
        const contract = this.contract || this.selectedContract;
        const contractEndDate = contract && contract.end && CalendarDate.parse(contract.end);
        let _cannotEndAfter = contractEndDate && CalendarDate.parse(contractEndDate);

        const contractStartDate = contract && contract.start && CalendarDate.parse(contract.start);
        const contractorStartDate = this.form.startDate && CalendarDate.parse(this.form.startDate);
        let _cannotEndBefore = contractStartDate ? (contractorStartDate && contractorStartDate.isAfter(contractStartDate) ? contractorStartDate : contractStartDate) : contractorStartDate;

        const cannotEndAfter = _cannotEndAfter && CalendarDate.parse(_cannotEndAfter)!.asDate;
        const cannotEndBefore = _cannotEndBefore && CalendarDate.parse(_cannotEndBefore)!.asDate;

        return { from: cannotEndAfter, to: cannotEndBefore };
      },
    },
  };
}
